export default __webpack_public_path__ + "static/media/webscrolls.28237c0b.png";